import React from 'react'
import { observer } from 'mobx-react-lite'

// import HeaderImg from '../../../static/community.png'
// import { motion } from 'framer-motion'

// import { useStore } from '../../../lib/context'

import css from 'styled-jsx/css'
// import { use100vh } from 'react-div-100vh'
import { getContentfulImageURL } from '../../../lib/helpers'

const { className, styles } = css.resolve`

`

const LineBreakSerializer = ({ content }) => {
	const nodes = content.split('\n')
	return nodes.map((s, i) => {
		if (i !== nodes.length - 1) {
			return (
				<React.Fragment key={`hl-l-s-${s}-${i}`}>
					{s}
					<br />
				</React.Fragment>
			)
		} else {
			return s
		}
	})
}

const Caption = ({ content }) => {
	if (!content) return null

	return (
		<div className="caption">
			{content}
			<style jsx>{`
				div {
					grid-column: 1/-1;

					padding: 0.625rem 5rem;
					width: 100%;
					display: flex;
					justify-content: center;
					opacity: 0.8;
					font-size: var(--font--xxs);
				}
			`}</style>
		</div>
	)
}

const CommunityLandingPage = observer(
	(props, ref) => {


		const image = props?.data?.backgroundImage?.file?.url || "";
		const imageSrc = getContentfulImageURL(image, 1600, 85);

		return (
			<div ref={ref} className={className} >
				<div className="image">
					<img className={className} src={imageSrc} alt="" />
				</div>
				<Caption content={'Illustration by Richard A. Chance'} />
				<div className="written-section">

					<p className="statement">
						{props.data.statement.statement}
					</p>

				</div>
				{styles}
				<style jsx>{`
					.image {
						display: block;
						width: 100%;
						height: 0;
						overflow: hidden;
						padding-bottom: 45.25%;
						position: relative;
					}

					.image img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
					.written-section {
						padding: 100px 0;
					}

					.headline-community {
						display: flex;
						font-weight: 700;
						justify-content: center;
						align-items: center;
						font-family: 'Elizeth';
						font-size: var(--font--m);
						margin-bottom: 0.625rem;
					}

					.written-section {
						width: 750px;
						margin 0 auto;
						text-align: center;
					}

					.statement {
						font-size: 36px;
						color: rgb(112, 112, 112);
					}

					@media (max-width: 769px), (pointer: coarse) {
						.image {
							padding-bottom: 110.25%;

						}
						.written-section {
							width: 100%;
							padding: 100px 20px;
						}

						.statement {
							font-size: 26px;
						}
					}

				`}</style>
			</div>
		)
	},
	{ forwardRef: true }
)

export default CommunityLandingPage
